module.exports = __webpack_public_path__ + "static/media/repair_service.43583738.png";